{
  "app": {
    "title": "Your Personal Planning Companion",
    "subtitle": "Organize • Plan • Achieve"
  },
  "header": {
    "brand": "Master Your Moments",
    "tagline": "Plan Smart • Live Well"
  },
  "common": {
    "loading": "Loading...",
    "retry": "Retry",
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "info": "Info",
    "add": "Add",
    "delete": "Delete",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "empty": "Empty",
    "notFound": "Not Found"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "habit": "Habit Tracker",
    "weekly": "Weekly Planner",
    "tasks": "Study & Work Plans",
    "finance": "Financial Management",
    "settings": "Settings"
  },
  "dashboard": {
    "title": "Dashboard",
    "habitProgress": "Habit Progress",
    "weeklyProgress": "Weekly Progress",
    "tasksProgress": "Tasks Summary",
    "financeBalance": "Finance Balance",
    "bookmarks": "Bookmarks",
    "tools": "Tools",
    "todayDate": "Today's Date",
    "tasks": "Tasks",
    "accessibility": "Accessibility",
    "addAccess": "Add Access",
    "weatherForecast": "Weather Forecast",
    "motivation": "Motivation",
    "notes": "Notes",
    "poem": "Poem",
    "positive": "Positive"
  },
  "habit": {
    "title": "Habit Tracker",
    "addNew": "Add New Habit",
    "monthlyGoal": "Monthly Goal",
    "days": "days",
    "progress": "Progress",
    "noHabits": "No habits recorded",
    "deleteConfirm": "Are you sure?",
    "day": "Day",
    "quickAdd": "Quick Add...",
    "total": "Total Habits",
    "today": "Today",
    "longestStreak": "Longest Streak",
    "markDoneToday": "Mark Done Today",
    "markUndone": "Mark Undone",
    "renamePrompt": "Enter new habit name",
    "hint": "Set monthly goal",
    "clear": "Clear",
    "streakInfo": "Consecutive days streak",
    "stats": "Statistics",
    "completePercent": "Completion %",
    "completedDays": "Completed Days",
    "totalDays": "Total Days",
    "best": "Best",
    "currentMonth": "This Month",
    "allHabits": "All Habits",
    "active": "Active",
    "completed": "Completed",
    "pending": "Pending",
    "frequency": "Frequency",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "reminder": "Reminder",
    "notifications": "Notifications",
    "enableReminders": "Enable Reminders",
    "reminderTime": "Reminder Time",
    "color": "Color",
    "icon": "Icon",
    "category": "Category",
    "description": "Description",
    "notes": "Notes",
    "history": "History",
    "thisMonth": "This Month",
    "lastMonth": "Last Month",
    "year": "Year",
    "export": "Export",
    "import": "Import",
    "achievements": "Achievements",
    "badges": "Badges",
    "milestone": "Milestone"
  },
  "weekly": {
    "title": "Weekly Planner",
    "viewMode": "View Mode",
    "weekView": "Week View",
    "listView": "List View",
    "addTask": "Add Task",
    "newTask": "New Task",
    "noTasks": "No tasks planned",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "today": "Today",
    "totalTasks": "Total Tasks",
    "completed": "Completed",
    "pending": "Pending",
    "progressPercentage": "Progress %",
    "filterAll": "All",
    "filterPending": "Pending",
    "filterCompleted": "Completed",
    "total": "Total",
    "inProgress": "In Progress",
    "taskText": "Task text...",
    "priorities": "Priorities",
    "addButton": "Add",
    "nextDays": "Next Days",
    "previousDays": "Previous Days",
    "priorityGuide": "Priority Guide"
  },
  "tasks": {
    "title": "Study & Work Plans",
    "newTask": "New Task",
    "addTask": "Add",
    "category": "Category",
    "priority": "Priority",
    "general": "General",
    "study": "Study",
    "work": "Work",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "noTasks": "No tasks available",
    "allCategories": "All Categories",
    "allPriorities": "All Priorities",
    "taskTitle": "Task Title",
    "addSection": "Add Section",
    "repeat": "Repeat",
    "list": "List",
    "filter": "Filter",
    "status": "Status",
    "taskText": "Task text..."
  },
  "finance": {
    "title": "Financial Management",
    "income": "Income",
    "expense": "Expense",
    "balance": "Balance",
    "addIncome": "Add Income",
    "addExpense": "Add Expense",
    "amount": "Amount",
    "date": "Date",
    "description": "Description",
    "noItems": "No items recorded",
    "totalIncome": "Total Income",
    "totalExpense": "Total Expense",
    "netBalance": "Net Balance",
    "incomeCategories": ["Salary", "Investment", "Other"],
    "expenseCategories": ["Food", "Transportation", "Entertainment", "Education", "Other"],
    "dashboard": "Dashboard",
    "analysis": "Analysis & Charts",
    "transactions": "Transactions",
    "recordTransaction": "Record Transaction",
    "recentTransactions": "Recent Transactions",
    "transactionCount": "Transaction Count",
    "compareLastMonth": "Compared to Last Month",
    "exportImage": "Export Image",
    "exportExcel": "Export Excel"
  },
  "settings": {
    "title": "Settings",
    "theme": "Theme",
    "language": "Language",
    "calendar": "Calendar",
    "light": "Light",
    "dark": "Dark",
    "persian": "Persian",
    "english": "English",
    "jalali": "Jalali",
    "gregorian": "Gregorian",
    "backup": "Backup",
    "export": "Export",
    "import": "Import",
    "clear": "Clear",
    "clearConfirm": "This action cannot be undone. Are you sure?",
    "clocks": "World Clocks",
    "weather": "Weather",
    "addClock": "Add Clock",
    "addWeather": "Add City",
    "clearHabits": "Clear All Habits",
    "clearHabitsShort": "Habits",
    "clearHabitsDescription": "This will permanently delete all habits and their associated data. This action cannot be undone.",
    "clearHabitsWarning": "⚠️ WARNING: All habits and their history will be deleted!\n\nThis action is permanent and you cannot restore the data.\n\nDo you want to continue?",
    "clearHabitsSuccess": "✅ All habits have been successfully cleared\n\nYour habits data has been deleted.",
    "clearFinance": "Financial Management",
    "clearFinanceWarning": "⚠️ WARNING: All incomes and expenses will be deleted!\n\nThis action is permanent and you cannot restore financial records.\n\nDo you want to continue?",
    "clearFinanceSuccess": "✅ All financial records have been successfully cleared\n\nYour financial data has been deleted.",
    "clearTasks": "Study & Work Plans",
    "clearTasksWarning": "⚠️ WARNING: All tasks will be deleted!\n\nThis action is permanent and you cannot restore deleted tasks.\n\nDo you want to continue?",
    "clearTasksSuccess": "✅ All tasks have been successfully cleared\n\nYour tasks data has been deleted.",
    "clearWeekly": "Weekly Planner",
    "clearWeeklyWarning": "⚠️ WARNING: All weekly plans will be deleted!\n\nThis action is permanent and you cannot restore the plans.\n\nDo you want to continue?",
    "clearWeeklySuccess": "✅ All weekly plans have been successfully cleared\n\nYour weekly planning data has been deleted.",
    "plannerName": "Planner Name",
    "save": "Save",
    "gregorianCalendar": "Gregorian Calendar",
    "jalaliCalendar": "Jalali Calendar",
    "persianText": "Persian Text"
  },
  "error": {
    "title": "An Error Occurred",
    "generic": "An unknown error occurred",
    "loadFailed": "Failed to load",
    "saveFailed": "Failed to save",
    "deleteFailed": "Failed to delete"
  },
  "success": {
    "saved": "Saved successfully",
    "added": "Added successfully",
    "deleted": "Deleted successfully",
    "updated": "Updated successfully"
  },
  "jalaliDatePicker": {
    "year": "Year",
    "month": "Month",
    "day": "Day",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "dashboardStats": {
    "dailyHabits": "Daily Habits",
    "activeStatus": "Active",
    "trend": "Trend",
    "upward": "Upward",
    "weeklyPlans": "Weekly Plans",
    "totalTasks": "Total Tasks",
    "essentialWork": "Essential Work",
    "tasksLabel": "Tasks",
    "from": "of",
    "highPriority": "High",
    "mediumPriority": "Medium",
    "lowPriority": "Low",
    "financeBalance": "Finance",
    "income": "Income",
    "expense": "Expense",
    "balance": "Balance"
  },
  "weeklyPlanner": {
    "dayNames": {
      "saturday": "Saturday",
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday"
    },
    "status": {
      "pending": "Pending",
      "ongoing": "Ongoing",
      "completed": "Completed"
    },
    "priority": {
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    }
  },
  "calendar": {
    "jalaliMonths": [
      "Farvardin",
      "Ordibehesht",
      "Khordad",
      "Tir",
      "Mordad",
      "Shahrivar",
      "Mehr",
      "Aban",
      "Azar",
      "Dey",
      "Bahman",
      "Esfand"
    ]
  }
}

